/**
 * Heuro Cinema - API Client
 * Fetches configuration from the backend.
 */

import type { PropertyConfig, PropertiesList } from '../types/content';

const API_BASE = '/api';

/**
 * Fetch the list of available properties.
 */
export async function fetchProperties(): Promise<PropertiesList> {
  const response = await fetch(`${API_BASE}/properties`);
  if (!response.ok) {
    throw new Error(`Failed to fetch properties: ${response.statusText}`);
  }
  return response.json();
}

/**
 * Fetch configuration for a specific property.
 */
export async function fetchPropertyConfig(
  propertyId: string,
  lang: string = 'en'
): Promise<PropertyConfig> {
  const response = await fetch(
    `${API_BASE}/property/${propertyId}?lang=${lang}`
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch property ${propertyId}: ${response.statusText}`
    );
  }
  return response.json();
}

/**
 * Determine property ID from hostname.
 * Falls back to 'heuro.business' for development.
 */
export function getPropertyIdFromHost(): string {
  const hostname = window.location.hostname;

  // Development fallback
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'heuro.business';
  }

  // Production: use hostname as property ID
  return hostname;
}